import React from 'react';

import {
    makeStyles,
    Paper,
    Typography,
    Avatar
} from '@material-ui/core';
import {
    api,
    Link
} from '@portal/arq-portal-core';

import { TabProps } from '../shared/TabProps';
import { ResultadoVacio } from './ResultadoVacio';
import { remarcarCoincidencias } from '../utils/Utils';
import { withPagination } from './withPagination';

const PREFIJO_USUARIO_SVC = 'https://grupoaplicaciones.gco.global/GCO.InfSoporteFiliales.Web.Portal/SiteUsuario/Default.aspx?S_usuario=XXXX&onexit=close';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: '15px 60px',
        justifyContent: 'flex-start',
        color: '#606060',
        gap: 25,
        '@media screen and (max-width: 959px)': {
            padding: '15px 20px',
        },
        '& p': {
            color: '#606060',
        },
    },
    tarjeta: {
        display: 'flex',
        padding: 0,
        minWidth: 'calc(50% - 15px)',
        alignItems: 'center',
        borderRadius:'0px',
        '@media screen and (max-width: 959px)': {
            minWidth: '100%'
        }
    },
    tarjetaContent: {
        paddingLeft: '20px',
    },
    iconoPersona: {
        height: '80px',
        width: '80px',
        backgroundColor: '#FFFFFF',
        '& :first-child': {
            color: '#DC0028',
            fontWeight: 'bold',
        },
        '& img': {
            height: '80px',
            width: '80px',
        }
    },
    nombre: {
        color: '#DC0028',
        fontWeight: 'bold'
    },
    info: {
        margin: '3px 0',
        fontSize: '14px'
    }
});

const TabPersonas = ({ texto, resultados, error }: TabProps) => {

    const clases = useStyles();
    const obtenerImagenUrl = (usuario: string, compania: string) => {
        let domain = compania;
        if (compania.toLowerCase().indexOf('sco') > -1) {
            domain = 'SCO';
        } else if (compania.toLowerCase().indexOf('gco') > -1) {
            domain = 'GCO';
        }
        return `${api.getApiServer()}/useravatar/?username=${usuario}&domain=${domain}`;
    }

    return (
        <React.Fragment>
            {resultados && !error &&
                <div className={clases.root}>
                    {resultados.length > 0 ?
                        resultados.map((persona: any) => 
                            <Paper variant='outlined' className={clases.tarjeta}>
                                <Avatar alt='Usuario Avatar' src={obtenerImagenUrl(persona.s_UIDRACF, persona.s_COMPANY)} variant='square' className={clases.iconoPersona}>
                                    <i className='icon-contactos'></i>
                                </Avatar>
                                <div className={clases.tarjetaContent}>
                                    <Link to={`${PREFIJO_USUARIO_SVC.replace('XXXX', persona.s_UIDRACF)}`} className={clases.nombre} dangerouslySetInnerHTML={{ __html: remarcarCoincidencias(persona.s_NOMBRECOMPLETO, texto) }}></Link>
                                    <p className={clases.info} dangerouslySetInnerHTML={{ __html: remarcarCoincidencias(persona.s_DESINFO, texto) }}></p>
                                    <Typography variant='body2'>{persona.s_INFOTER}</Typography>
                                </div>
                            </Paper>) :
                        <ResultadoVacio />
                    }
                </div>
            }
            {error &&
                <Paper style={{ margin: "60px 80px", paddingBottom: '35px' }} elevation={0} square>
                    <h4>Ha ocurrido un error y no se pudo obtener información de Personas en este momento</h4>
                    <h5>Por favor intente nuevamente más tarde</h5>
                </Paper>
            }
        </React.Fragment>
    );
};

export const TabPersonasPaginado = withPagination(TabPersonas, 10);
